import { render, staticRenderFns } from "./_header.vue?vue&type=template&id=0fd60d7a&scoped=true&"
import script from "./_header.vue?vue&type=script&lang=js&"
export * from "./_header.vue?vue&type=script&lang=js&"
import style0 from "./_header.vue?vue&type=style&index=0&id=0fd60d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd60d7a",
  null
  
)

export default component.exports